module.exports = __webpack_public_path__ + "img/voice.73cbfcb6.png";